/**
 * Copyright (c) Microsoft. All rights reserved.
 */

import { autorun } from 'mobx';
import * as React from 'react';
import { Intent } from 'src/luis/modules/intents/Intent';
import { intentsDenormalizer } from 'src/luis/modules/intents/intentsDenormalizer';
import { useModels } from 'src/luis/modules/models/useModels';

/**
 * A hook used to initialize the app intents by doing the following.
 * 1) Fetches the current app intents, entities and phrase lists.
 * 2) Return the intents and the loading state from the intent store house.
 */
export const useIntents = () => {
    const { entityStores, intentStores, phraseListStores, isLoaded, isLoading } = useModels();
    const loadIntents = () => (isLoaded ? intentsDenormalizer(intentStores, entityStores, phraseListStores) : []);
    const [intents, setIntents] = React.useState<Intent[]>(loadIntents);

    React.useEffect(() => autorun(() => setIntents(loadIntents())), [isLoaded, intentStores, entityStores, phraseListStores]);

    return { intents, isLoaded, isLoading };
};
